<template>
  <v-container fluid>
    <base-material-card icon="mdi-history" title="Historial de Cambios" class="px-5 py-3">
      <v-row>
        <v-col cols="12">
          <v-data-table
            :headers="headers"
            :items="filteredLogs"
            item-key="id"
            class="elevation-1"
          >
            <template v-slot:top>
                <v-row class="px-4" no-gutters align="center" dense>
                  <v-col cols="6" sm="3" md="3">
                    <v-select
                      v-model="filteredUser"
                      :items="usersAvailable"
                      label="Filtrar por usuario"
                      clearable
                      outlined
                    />
                  </v-col>

                  <v-col cols="6" sm="3" md="3" class="pl-2">
                    <v-select
                      v-model="filteredProfile"
                      :items="profilesAvailable"
                      label="Filtrar por perfil"
                      clearable
                      outlined
                    />
                  </v-col>

                  <v-col cols="6" sm="3" md="3" class="pl-2">
                    <v-menu
                      v-model="startMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="startDateFormatted"
                          label="Fecha inicio"
                          prepend-icon="mdi-calendar"
                          clearable
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="startDate"
                        @input="startMenu = false"
                        scrollable
                      />
                    </v-menu>
                  </v-col>

                  <v-col cols="6" sm="3" md="3" class="pl-2">
                    <v-menu
                      v-model="endMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="endDateFormatted"
                          label="Fecha fin"
                          prepend-icon="mdi-calendar"
                          clearable
                          outlined
                          v-bind="attrs"
                          v-on="on"
                        />
                      </template>
                      <v-date-picker
                        v-model="endDate"
                        @input="endMenu = false"
                        scrollable
                      />
                    </v-menu>
                  </v-col>
                </v-row>

                <v-row class="px-4 pt-2" no-gutters align="center" dense>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      v-model="search"
                      outlined
                      label="Buscar en historial..."
                      clearable
                    />
                  </v-col>
                </v-row>
              </template>


            <template v-slot:item.fecha="{ item }">
              <span>{{ formatDate(item.fecha) }}</span>
            </template>

            <template v-slot:item.usuario="{ item }">
              {{ item.usuario }}
            </template>

            <template v-slot:item.fase="{ item }">
              <span>{{ moduleName(item.fase) }}</span>
            </template>

            <template v-slot:item.accions="{ item }">
              <v-tooltip top>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    v-bind="attrs"
                    v-on="on"
                    small
                    class="mr-2"
                    @click="inspectProject(item)"
                  >
                    mdi-eye
                  </v-icon>
                </template>
                <span>Ver detalles del proyecto </span>
              </v-tooltip>
            </template>
          </v-data-table>

          <v-alert v-if="filteredLogs.length === 0" type="info" elevation="2" class="mt-4">
            No hay registros disponibles.
          </v-alert>
        </v-col>
      </v-row>
      <v-dialog v-model="isLogDetailsDialogVisible" max-width="600px">
        <v-card>
          <v-card-title class="headline">Detalles del Log</v-card-title>
          <v-card-text v-if="selectedLog">
            <p><strong>Proyecto:</strong> {{ selectedLog.nombreProyecto }}</p>
            <p><strong>Usuario:</strong> {{ selectedLog.usuario }}</p>
            <p><strong>Perfil:</strong> {{ selectedLog.perfil }}</p>
            <p><strong>Comentario:</strong> {{ selectedLog.comentario }}</p>
            <p><strong>Fecha:</strong> {{ formatDate(selectedLog.fecha) }}</p>
            <p><strong>Región:</strong> {{ selectedLog.region }}</p>
            <p><strong>Provincia:</strong> {{ selectedLog.provincia }}</p>
            <p><strong>Módulo:</strong> {{ moduleName(selectedLog.fase) }}</p>
          </v-card-text>
          <v-card-actions>
            <v-spacer />
            <v-btn color="primary" text @click="isLogDetailsDialogVisible = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </base-material-card>
  </v-container>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'

export default {
  name: 'logGlobal',
  data() {
    return {
      filteredUser: null,
      filteredProfile: null,
      logs: [],
      loading: false,
      error: null,
      search: '',
      startDate: null,
      endDate: null,
      startMenu: false,
      endMenu: false,
      isLogDetailsDialogVisible:false,
      selectedLog:null,
    }
  },
  computed: {
    headers() {
      return [
        {
          text: 'Proyecto',
          align: 'start',
          value: 'nombreProyecto',
        },
        {
          text: 'Usuario',
          value: 'usuario',
        },
        {
          text: 'Perfil del Usuario',
          value: 'perfil',
        },
        {
          text: 'Acción Realizada',
          value: 'comentario',
        },
        {
          text: 'Fecha',
          value: 'fecha',
        },
        {
          text: 'Región',
          value: 'region',
        },
        {
          text: 'Provincia',
          value: 'provincia',
        },
        {
          text: 'Modulo',
          value: 'fase',
        },
        {
          text: 'Acciones',
          value: 'accions',
        },
      ]
    },
    filteredLogs() {
      const searchLower = this.search.trim().toLowerCase()

      return this.logs.filter(log => {
        let matchesText =
          !searchLower ||
          (log.nombreProyecto && log.nombreProyecto.toLowerCase().includes(searchLower)) ||
          (log.comentario && log.comentario.toLowerCase().includes(searchLower)) ||
          (log.usuario && log.usuario.toLowerCase().includes(searchLower)) ||
          (log.region && log.region.toLowerCase().includes(searchLower)) ||
          (log.provincia && log.provincia.toLowerCase().includes(searchLower))

        let matchesDate = true
        if (this.startDate) {
          const logDate = log.fecha.toDate ? log.fecha.toDate() : new Date(log.fecha)
          matchesDate = logDate >= new Date(this.startDate)
        }
        if (matchesDate && this.endDate) {
          const logDate = log.fecha.toDate ? log.fecha.toDate() : new Date(log.fecha)
          matchesDate = logDate <= new Date(this.endDate + 'T23:59:59')
        }

        if (this.filteredUser) {
          matchesText = matchesText && log.usuario === this.filteredUser
        }

        if (this.filteredProfile) {
          matchesText = matchesText && log.perfil === this.filteredProfile
        }

        return matchesText && matchesDate
      })
    },
    startDateFormatted() {
      return this.startDate ? this.startDate : ''
    },
    endDateFormatted() {
      return this.endDate ? this.endDate : ''
    },
    usersAvailable() {
      return [...new Set(this.logs.map(l => l.usuario).filter(Boolean))]
    },
    profilesAvailable() {
      return [...new Set(this.logs.map(l => l.perfil).filter(Boolean))]
    },
  },
  methods: {
    async fetchLogs() {
      this.loading = true
      this.error = null
      try {
        const db = firebase.firestore()
        const snapshot = await db.collection('globalLog').get()
        this.logs = snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() }))
        console.log(this.logs)
      } catch (e) {
        console.error('Error cargando historial:', e)
        this.error = 'Error cargando historial'
      } finally {
        this.loading = false
      }
    },
    formatDate(fecha) {
      if (!fecha) return ''
      const date = fecha.toDate ? fecha.toDate() : new Date(fecha)
      return date.toLocaleString('es-PE', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
      })
    },
    moduleName(fase) {
      const map = {
        1: 'Prospección',
        2: 'Aprobación',
        3: 'Negociación',
      }
      return map[fase] || 'Modulo desconocido'
    },
    async inspectProject(item) {
      try {
        const db = firebase.firestore()
        const docRef = await db.collection('globalLog').doc(item.id).get()

        if (!docRef.exists) {
          console.log('No se encontró el log con ID:', item.id)
          return
        }

        this.selectedLog = docRef.data()
        this.isLogDetailsDialogVisible=true
        console.log('Detalles del log:', this.selectedLog)
      } catch (error) {
        console.error('Error buscando el log:', error)
      }
    },
    clearFilters() {
      this.search = ''
      this.startDate = null
      this.endDate = null
    },
  },
  created() {
    this.fetchLogs()
  },
}
</script>